import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP_HEADERS } from '@improver/core';
import { Observable } from 'rxjs';
import { isInstanceRequest } from './interceptors.utils';

@Injectable()
export class SessionInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.headers.has(HTTP_HEADERS.REQUEST_ID)) {
      const headers = isInstanceRequest(request.url)
        ? request.headers.set(HTTP_HEADERS.REQUEST_ID, this.generateRequestId())
        : request.headers.delete(HTTP_HEADERS.REQUEST_ID);

      return next.handle(request.clone({ headers }));
    }

    return next.handle(request);
  }

  private generateRequestId(): string {
    return `${new Date().valueOf()}_${Math.random()}`;
  }
}
